module.exports = __webpack_public_path__ + "static/media/lesson-backto12.572fb0c8.png";